import type { Account } from '../types';

type AccountStatus = Account['status'];

type StatusPresentation = {
  badgeVariant: 'success' | 'secondary';
  lifecycleLabel: string;
  actionLabel: string;
  confirmTitle: string;
  confirmDescription: string;
  actionVerb: string;
  nextStatus: 'active' | 'suspended';
  actionClassName: string;
};

export function getAccountStatusPresentation(status: AccountStatus): StatusPresentation {
  switch (status) {
    case 'active':
      return {
        badgeVariant: 'success',
        lifecycleLabel: 'Active since',
        actionLabel: 'Suspend Account',
        confirmTitle: 'Suspend Account',
        confirmDescription:
          'Are you sure you want to suspend this account? The account will be marked as suspended and may affect access to services.',
        actionVerb: 'Suspend',
        nextStatus: 'suspended',
        actionClassName: 'bg-warning hover:bg-warning/90 text-white',
      };
    case 'onboarding':
      return {
        badgeVariant: 'secondary',
        lifecycleLabel: 'Onboarding since',
        actionLabel: 'Mark Account Active',
        confirmTitle: 'Mark Account Active',
        confirmDescription:
          'Are you sure you want to mark onboarding complete and activate this account?',
        actionVerb: 'Mark Active',
        nextStatus: 'active',
        actionClassName: 'bg-success hover:bg-success/90 text-white',
      };
    default:
      return {
        badgeVariant: 'secondary',
        lifecycleLabel: status === 'churned' ? 'Churned on' : 'Status since',
        actionLabel: 'Activate Account',
        confirmTitle: 'Activate Account',
        confirmDescription:
          'Are you sure you want to activate this account? The account will be marked as active and services will be restored.',
        actionVerb: 'Activate',
        nextStatus: 'active',
        actionClassName: 'bg-success hover:bg-success/90 text-white',
      };
  }
}
